import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Table, Container, Row, Col, Form } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-regular-svg-icons';

import LoginHeader from '../Login_header';
import Menu from '../Menu';
import * as Common from '../Common';
import Dialog from '../Dialog';
import DialogYesNo from '../Dialog_Yes_No';
import ActivityLog from '../ActivityLog';
import $ from "jquery";

function Master_state_list() {
    const navigate = useNavigate();
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [stateData, setStateData] = useState([]);

    const [showAddNewBtn, setShowAddNewBtn] = useState(true);
    const [showAddEditForm, setAddEditFormShow] = useState(false);
    const [srNo, setSrNo] = useState(0);
    const [state, setState] = useState("");

    const [remark, setRemark] = useState("");

    const [status, setStatus] = useState(0);
    const [ddActiveOptions, setDdActiveOptions] = useState([]);

    const [country, setCountry] = useState(0);
    const [ddCountryOptions, setDdCountryOptions] = useState([]);

    const [sttType, setSttType] = useState("S");

    const [filterActive, setFilterActive] = useState(0);
    const [ddFilterActiveOptions, setDdFilterActiveOptions] = useState([]);

    const [userRight, setUserRight] = useState([]);

    const [formMode, setFormMode] = useState('Q'); // Q A E 

    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");

    const [showActivityLog, setShowActivityLog] = useState(false);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            setDdActiveOptions([{ name: 'Active', value: "1" }, { name: 'Inactive', value: "0" }]);
            Common.callApi(Common.apiCountry, [sid, 'ddlistjson'], function (result) {
                setDdCountryOptions(JSON.parse(result));
                setDdFilterActiveOptions(JSON.parse(result));
                setFilterActive(0);
                /* Common.callApi(Common.apiState,[sid,'listjson',1],function(result){ 
                     setStateData(JSON.parse(result));
                 });*/
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'STATE'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    function getList(id) {
        setFilterActive(id);
        Common.callApi(Common.apiState, [sid, 'listjson', id], function (result) {
            setStateData(JSON.parse(result));
        });
    }

    function refreshList(id) {
        setFilterActive(id);
        getList(id);
    }

    function addNew() {
        setSrNo(0);
        // setActivityLog([]);
        setStatus(1);
        setFormMode('A');
        setState("");
        setSttType('S');
        setCountry(0);
        setAddEditFormShow(true);
        setShowAddNewBtn(false);
    }

    function saveData() {
        if (state === "" || country === 0) {
            setMsgText(Common.getMessage("MSG0006"));
            setMsgBox(true);
        } else if (formMode === 'E' && remark === '') {
            setMsgText('Please fill remark!');
            setMsgBox(true);
        } else {
            var object1 = {
                state: state,
                cnt: country,
                act: status,
                type: sttType,
                branch: 0,
                activitytype: srNo * 1 > 0 ? 'MODIFY' : 'CREATE',
                trancategory: 'M',
                trantype: 'MSTAT',
                trannumber: srNo,
                subtranno: 0,
                remark: remark,
            };
            $(".loader").show();
            Common.callApi(Common.apiState, [sid, 'save', srNo, JSON.stringify(object1)], function (result) {
                let resp = JSON.parse(result);
                if (resp.status) {
                    setAddEditFormShow(false);
                    setShowAddNewBtn(true);
                    setRemark("");
                    getList(filterActive);
                }
                    setMsgText(resp.message);
                    setMsgBox(true);
                
                $(".loader").hide();
            });
        }
    }

    const cancelConfirm = () => {
        if (formMode === "A" || formMode === "E") {
            setMsgTextYN('Do you really want to exit ?');
            setMsgBoxYN(true);
        } else {
            cancelData();
        }
    }

    const cancelData = () => {
        setMsgBoxYN(false);
        setAddEditFormShow(false);
        setShowAddNewBtn(true);
        setShowActivityLog(false);
    }

    // function cancelData() {
    //     setAddEditFormShow(false);
    //     setShowAddNewBtn(true);
    // }

    function fillEditForm(id) {
        setFormMode('Q');
        setShowActivityLog(false);
        Common.callApi(Common.apiState, [sid, 'detail', id], function (result) {
            let resp = JSON.parse(result);
            setSrNo(resp.srno);
            setState(resp.state);
            setCountry(resp.countrysrno);
            setStatus(resp.active);

            setAddEditFormShow(true);
            setShowAddNewBtn(false);
        });
    }

    const editData = () => {
        setFormMode('E');
    }

    const exportFile = () => {
        var obj = {
            right: 'STATE'
        }
        Common.callDownloadApiPost(Common.apiReport, "post", [sid, JSON.stringify(obj)]);
    }

    const btnActivityLog = () => {
        setShowActivityLog(true);
        setLogObject({ trantype: "MSTAT", trannumber: srNo, trancategory: "M" });
    }

    return (
        <>
            <LoginHeader />
            <Menu></Menu>
            <Container fluid >
                <Row>
                    <Col>
                        <h1>State Master </h1>
                    </Col>
                </Row>
                {showAddNewBtn ?
                    <Row>
                        <Col>
                            {userRight.add === "1" ?
                                <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={addNew}>Add New</Button>
                                : null}
                            {
                                userRight.query === "1" ?
                                    <>&nbsp;
                                        <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={exportFile}>Export</Button>
                                    </>
                                    : null
                            }
                        </Col>
                    </Row>
                    : null
                }
                <Row><Col>&nbsp;</Col></Row>
                {showAddEditForm ?
                    <>
                        <Row>
                            <Col className="divContentCenter">
                                <div className="maxFormWidth">
                                    <Form>
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Serial Number</Form.Label>
                                                    <Form.Control type="text" placeholder="Serial Number" value={srNo} disabled />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>State<span className="mandatory text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" placeholder="State" maxLength={50}
                                                        value={state}
                                                        onChange={(e) => Common.validateAlpValue(e.target.value, setState)}
                                                        autoComplete="off"
                                                        disabled={formMode === 'Q'} />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Country<span className="mandatory text-danger">*</span></Form.Label>
                                                    <Form.Select
                                                        value={country}
                                                        onChange={(e) => setCountry(e.target.value)}
                                                        disabled={formMode === 'Q'}
                                                    >
                                                        {ddCountryOptions.map((res) =>
                                                            <option key={res.value} value={res.value}>{res.name}</option>
                                                        )}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>State Type</Form.Label>
                                                    <Form.Select value={sttType} onChange={e => setSttType(e.target.value)}
                                                        disabled={formMode === 'Q'}
                                                        required>
                                                        <option value="S">State</option>
                                                        <option value="U">Union Territory</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Status</Form.Label>
                                                    <Form.Select
                                                        value={status}
                                                        onChange={(e) => setStatus(e.target.value)}
                                                        disabled={formMode === 'Q'}
                                                    >
                                                        {ddActiveOptions.map((res) =>
                                                            <option key={res.value} value={res.value}>{res.name}</option>
                                                        )}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col>&nbsp;</Col>
                                        </Row>
                                        {
                                            formMode === 'E' ?
                                                <>
                                                    <Row>
                                                        <Col>
                                                            <Form.Group>
                                                                <Form.Label>Remark<span className="mandatory text-danger">*</span></Form.Label>
                                                                <Form.Control type="text" placeholder="Remark" maxLength={50}
                                                                    value={remark}
                                                                    onChange={(e) => Common.validateAlpValue(e.target.value, setRemark)}
                                                                    autoComplete="off"
                                                                    required />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col>&nbsp;</Col>
                                                        <Col>&nbsp;</Col>
                                                        <Col>&nbsp;</Col>
                                                    </Row>
                                                </> :
                                                null
                                        }
                                        <Row><Col>&nbsp;</Col></Row>
                                        <Row>
                                            <Col>
                                                {/* <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => saveData()}>Save</Button>&nbsp;
                                            <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => cancelData()}>Cancel</Button> */}

                                                <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() =>
                                                    cancelConfirm()}>Back</Button>&nbsp;&nbsp;

                                                {
                                                    (userRight.edit === "1" && formMode === 'Q') ? <>
                                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                            editData()}>Edit</Button>&nbsp;
                                                    </> : null
                                                }
                                                {
                                                    (userRight.edit === "1" && formMode === 'E') || (userRight.add === "1" && formMode === 'A') ? <>
                                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                            saveData()}>Save</Button>&nbsp;
                                                    </> : null
                                                }
                                                {
                                                    (userRight.query === "1" && (formMode === 'E' || formMode === 'Q')) ? <>
                                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                            btnActivityLog()}>Activity Log</Button>&nbsp;
                                                    </> : null
                                                }
                                            </Col>
                                        </Row>
                                        <Row><Col>&nbsp;</Col></Row>
                                    </Form>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            {
                                showActivityLog &&
                                <>
                                    {/* <ActivityLog trantype='MSTAT' trannumber={srNo} trancategory="M" /> */}
                                    <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
                                </>
                            }
                        </Row>
                    </>
                    :
                    <>
                        <Row>
                            <Col>
                                <Form.Group>
                                    <Form.Select
                                        value={filterActive}
                                        onChange={(e) => refreshList(e.target.value)}>
                                        {ddFilterActiveOptions.map((res) =>
                                            <option key={res.value} value={res.value}>{res.name}</option>
                                        )}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col>&nbsp;</Col>
                            <Col>&nbsp;</Col>
                            <Col>&nbsp;</Col>
                        </Row>
                        <Row><Col>&nbsp;</Col></Row>
                        <Row>
                            <Col>
                                <Table responsive striped bordered hover>
                                    <thead>
                                        <tr>
                                            {userRight.query === "1" ? <th></th> : null}
                                            <th className="textRight">Sr No</th>
                                            <th>State</th>
                                            <th>Country</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {stateData.map((res) =>
                                            <tr key={res.state_id}>
                                                {userRight.query === "1" ?
                                                    <td className="textCenter" >
                                                        <span className="handCursor" onClick={() => fillEditForm(res.state_id)} >
                                                            <div className="colorThemeBlue"><FontAwesomeIcon icon={faEye} /></div>
                                                        </span>
                                                    </td>
                                                    : null
                                                }
                                                <td className="textRight">{res.state_id}</td>
                                                <td>{res.state_name}</td>
                                                <td>{res.cnt_name}</td>
                                                <td>{res.state_active}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </>
                }
            </Container>
            {/* <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div> */}

            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
                <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                    {msgTextYN}
                </DialogYesNo>
            </div>
        </>
    );
}
export default Master_state_list; 